module.exports = __webpack_public_path__ + "img/gif-diverse-combination.811fa3d7.gif";